import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { renderWhenTrue } from '../../utils/rendering';

export class DeferMount extends PureComponent {
  static propTypes = {
    timeout: PropTypes.number,
    children: PropTypes.node,
  };

  static defaultProps = {
    timeout: 500,
  };

  state = {
    isMounted: false,
  };

  componentDidMount() {
    this.timeout = setTimeout(() => this.setState({ isMounted: true }), this.props.timeout);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  timeout = null;

  render = () => renderWhenTrue(() => this.props.children)(this.state.isMounted);
}
